import React from 'react';

import CalendarTotalCount from './CalendarTotalCount';
import CalendarFilter from './CalendarFilter';
import SettingsAndCreateEventButton from './SettingsAndCreateEventButton';

import { useCalendarContext } from 'modules/calendar/Context/CalendarContext';

function CalendarHeader() {
  const { isClientCalendar } = useCalendarContext();

  return (
    <div className="mx-0 global-calendar-filters">
      <div className="col-12">
        <CalendarTotalCount />

        <div className="d-flex align-items-center justify-content-between flex-wrap mb-3 calendar-filter">
          {!isClientCalendar && <CalendarFilter />}
          {!isClientCalendar && <div className="d-flex align-items-center direction-column">{<SettingsAndCreateEventButton />}</div>}
        </div>
      </div>
    </div>
  );
}

export default CalendarHeader;
